import { overlayStrategemFadeMs } from './overlayStrategemTiming';

/** Strategem 341 (The Betrayal): overlay — bottom-center of art on target point (translate(-50%,-100%)) */
export const BETRAYAL_TARGET_IMAGE_PATH = '/images/betrayal_target.png';
export const BETRAYAL_SOUND_PATH = '/sounds/betrayal.mp3';
/** Time overlay stays visible before two-phase completion (strategem-animation-complete). */
export const BETRAYAL_TARGET_FADE_DURATION_MS = overlayStrategemFadeMs(341);

/** Matches battlefield overlay width for betrayal_target.png (~30% larger than Duplicate-sized overlay). */
export const BETRAYAL_TARGET_OVERLAY_WIDTH = 'min(57.2vw, 286px)';

/**
 * Applied after DOM anchor (viewport px). X shifts the horizontal anchor; positive Y moves the
 * anchor point down (overlay artwork shifts down with its bottom fixed to that point).
 */
export const BETRAYAL_TARGET_ANCHOR_OFFSET_X_PX = 100;
export const BETRAYAL_TARGET_ANCHOR_OFFSET_Y_PX = 0;

/** Applied to the targeted drone tile DOM node — brightness ramp instead of overlay image. */
export const BETRAYAL_DRONE_CELL_FLASH_CLASS = 'strategem-betrayal-drone-cell-flash';
